import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function SecureIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-secure-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.48 14.06V9.74c0-2.99 2.43-5.42 5.42-5.42h4.2c2.99 0 5.42 2.43 5.42 5.42v4.32h4.32V9.74C31.84 4.36 27.48 0 22.1 0h-4.2c-5.38 0-9.74 4.36-9.74 9.74v4.31h4.32zM32.46 15.51H7.54c-2.08 0-3.76 1.68-3.76 3.76v16.97c0 2.08 1.68 3.76 3.76 3.76h24.92c2.08 0 3.76-1.68 3.76-3.76V19.27c0-2.08-1.68-3.76-3.76-3.76zm-10.62 16v2c0 1.01-.82 1.84-1.84 1.84-1.01 0-1.84-.82-1.84-1.84v-2a4.186 4.186 0 01-2.36-3.76 4.2 4.2 0 118.4 0c0 1.66-.97 3.08-2.36 3.76z"
  })));
}